export const formatAt = (raw: string) =>
  new Date(raw).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export const hasDiff = (diff: unknown) =>
  diff !== null &&
  diff !== undefined &&
  !(typeof diff === 'object' && Object.keys(diff).length === 0);
